import Vue from 'vue'

Vue.mixin({
    computed: {
        isCompanyPrimaryUser() {
            return this.$store.getters['auth/authenticated'] === this.$store.getters['company/primaryUserId']
        }
    }
})
